import {Component, Input} from '@angular/core';

@Component({
    selector: 'db-cdn-overview',
    templateUrl: './cdn-overview.component.html',
    styleUrls: ['./cdn-overview.component.scss'],
    standalone: false
})
export class CdnOverviewComponent {

  @Input() isNameServer: boolean;
  constructor(
  ) { }
}
